export default {
      id: "ar_annuaire-usage",
      viewBox: "0 0 90 90",
      url: "../dist/images/" + "sprite.svg#ar_annuaire-usage",
      toString: function () {
        return this.url;
      }
    }